angular.module('tgaApp').constant('languageData', [
  {
    name: 'English(US)',
    code: 'en_us',
    language_id: 1,
  },
  {
    name: 'English(UK)',
    code: 'en_uk',
    language_id: 2,
  },
  {
    name: 'Hindi',
    code: 'hi',
    language_id: 3,
  },
  {
    name: '日本語(Japanese)',
    code: 'ja',
    language_id: 4,
  },
  {
    name: 'German',
    code: 'de',
    language_id: 5,
  },
  {
    name: '简体中文(Simplified Chinese)',
    code: 'zh',
    language_id: 6,
  },
  {
    name: 'Spanish',
    code: 'es',
    language_id: 7,
  },
  {
    name: 'French',
    code: 'fr',
    language_id: 8,
  },
  {
    name: 'Turkish',
    code: 'tr',
    language_id: 9,
  },
  {
    name: 'Portuguese',
    code: 'pt',
    language_id: 10,
  },
  {
    name: 'Italian',
    code: 'it',
    language_id: 11,
  },
  {
    name: 'Russian',
    code: 'ru',
    language_id: 12,
  },
  {
    name: '繁體中文(Traditional Chinese)',
    code: 'zh_hk',
    language_id: 13,
  },
  {
    name: '한국어(Korean)',
    code: 'ko',
    language_id: 14,
  },
  {
    name: 'Bahasa(Indonesian)',
    code: 'id',
    language_id: 15,
  },
  {
    name: 'คนไทย(Thai)',
    code: 'th',
    language_id: 16,
  },
]);
